<div class="contact-page modal">
    <form [formGroup]="registrarUsuarioForm" class="theme-form" (keydown.enter)="$event.preventDefault()">
        <div class="container d-flex justify-content-center">
            <div class="col-10 px-5 py-3 modal-body">
                <button class="close-button" (click)="closeModal()">X</button>
                <div class="col-sm-12">
                    <h3>Registrarse</h3>
                    <div class="row">
                        <!-- <div class="row mb-3 d-flex align-items-center">
                            <div class="col-md-3">
                                <h4><strong>¿Ya eres nuestro cliente?</strong></h4>
                            </div>
                            <div class="col-md-1 d-flex align-items-center">
                                <label>
                                    <input type="radio" class="mb-0" formControlName="YaEsCliente" [value]="true" />
                                    Si
                                </label>
                            </div>
                            <div class="col-md-1 d-flex align-items-center">
                                <label>
                                    <input type="radio" class="mb-0" formControlName="YaEsCliente" [value]="false" />
                                    No
                                </label>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <div class="theme-card row col-8 d-flex justify-content-center mb-3"
                                *ngIf="registrarUsuarioForm.get('YaEsCliente').value === true">
                                <div class="col-md-5">
                                    <i class="fa fa-phone"></i>&nbsp;
                                    <label for="nombre">Teléfono GIGMAX</label>
                                    <input formControlName="phoneNumber" class="form-control" id="nombre" maxlength="10"
                                        (input)="soloNumeros($event)" required />
                                </div>
                                <div class="col-md-5">
                                    <i class="fa fa-phone"></i>&nbsp;
                                    <label for="nombre">N° de Cuenta</label>
                                    <input formControlName="NumeroCliente" class="form-control" id="nombre" required />
                                </div>
                            </div>
                        </div> -->
                        <div class="col-md-4">
                            <i class="fa fa-id-card"></i>&nbsp;
                            <label for="nombre">Nombre</label>
                            <input formControlName="nombre" class="form-control" id="nombre" required>
                            <span class="text-danger"
                                *ngIf="(registrarUsuarioForm.get('nombre').touched) && registrarUsuarioForm.get('nombre').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-4">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="apellidoPaterno">Apellido Paterno</label>
                            <input formControlName="apellidoPaterno" class="form-control" id="apellidoPaterno" required>
                            <span class="text-danger"
                                *ngIf="(registrarUsuarioForm.get('apellidoPaterno').touched) && registrarUsuarioForm.get('apellidoPaterno').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-4">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="apellidoMaterno">Apellido Materno</label>
                            <input formControlName="apellidoMaterno" class="form-control" id="apellidoMaterno" required>
                            <span class="text-danger"
                                *ngIf="(registrarUsuarioForm.get('apellidoMaterno').touched) && registrarUsuarioForm.get('apellidoMaterno').errors?.required">
                                Campo requerido
                            </span>
                        </div>
                        <div class="col-md-4  mt-1">
                            <i class="fa fa-id-badge"></i>&nbsp;
                            <label for="fechaNacimiento">Fecha de nacimiento <span class="text-danger">* </span><span
                                    style="font-style: italic; color: gray">Debes ser mayor de edad para
                                    registrarte</span></label>
                            <dx-date-box class="form-control" [(value)]="fechaNacimiento" [min]="min" type="date"
                                [max]="max" invalidDateMessage="Ingrese una fecha válida">
                                <dx-validator>
                                    <dxi-validation-rule type="required"
                                        message="Campo requerido"></dxi-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                        </div>
                        <div class="col-md-4 mt-1">
                            <i class="fa fa-envelope"></i>&nbsp;
                            <label id="correo">Correo</label>
                            <input formControlName="correo" class="form-control" id="correo" autocomplete="username"
                                required="required">
                            <span class="text-danger"
                                *ngIf="(registrarUsuarioForm.get('correo').touched) && registrarUsuarioForm.get('correo').errors?.required">
                                Campo requerido
                            </span>
                            <span class="text-danger"
                                *ngIf="(registrarUsuarioForm.get('correo').touched) && registrarUsuarioForm.get('correo').hasError('pattern')">
                                Ingrese un correo válido
                            </span>
                        </div>
                        <div class="col-md-4 mt-1">
                            <i class="fa fa-phone"></i>&nbsp;
                            <label for="nombre">Teléfono</label>
                            <input formControlName="Telefono" class="form-control" id="nombre" maxlength="10"
                                (input)="soloNumeros2($event)" required />
                        </div>
                        <div class="col-md-6 mt-1" formGroupName="passwordGroup">
                            <i class="fa fa-key"></i>&nbsp;
                            <label id="pws1">Contraseña</label>
                            <div class="cont-icon-eye">
                                <input (keyup)="onPasswordInput($event)" [type]="hidePass ? 'password' : 'text'"
                                    autocomplete="new-password" style="width: 100% !important;" 
                                    maxlength="16"
                                    pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$"
                                    formControlName="password" required="required" class="form-control">
                                <span class="toggle-password"
                                    [ngClass]="{'show-password': !hidePass, 'hide-password': hidePass}"
                                    (click)="togglePassword('password')"></span>
                            </div>
                            <p class="mb-0"> <i class="fa fa-check-circle"
                                    [ngClass]="{'checked': minCaracteres && maxCaracteres}" aria-hidden="true"></i> La
                                contraseña debe tener más de 6 caracteres y menos de 16.</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasMayus && hasMinus}"
                                    aria-hidden="true"></i> Al menos una mayúscula y minúsculas.</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': espCaracter}"
                                    aria-hidden="true"></i> Un caracter no alfanumérico (ejemplo: #?!&).</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasNumber}"
                                    aria-hidden="true"></i> Un número.</p>
                        </div>
                        <div class="col-md-6 mt-1">
                            <div formGroupName="passwordGroup">
                                <i class="fa fa-key"></i>&nbsp;
                                <label id="matLabel">Confirmar Contraseña</label>
                                <div class="cont-icon-eye">
                                    <input (keyup.enter)="registrarUsuario()" maxlength="16"
                                        [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword"
                                        autocomplete="new-password" required="required"
                                        class="form-control input-danger">
                                    <span class="toggle-password"
                                        [ngClass]="{'show-password': !hideConfirm, 'hide-password': hideConfirm}"
                                        (click)="togglePassword('confirm')"></span>
                                </div>
                                <span class="text-danger"
                                    *ngIf="registrarUsuarioForm.get('passwordGroup').hasError('match') ">
                                    Las contraseñas no coinciden.
                                </span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center mt-1 align-items-center gap-3 flex-wrap">
                            <button class="btn btn-solid mt-1" (click)="registrarUsuario()">Registrarse</button> <br>
                            <a (click)="changeModal(true, false)"><span class="olvidoContrasena">¿Eres miembro? Inicia
                                    Sesión</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</div>